import i18n from '../i18n';
import {
  accSetTypeOptions,
  genderOptions,
  studioSetNumberOptions,
} from './general';

export const ecommTableNumericRows = [
  {// 0
    title: i18n.t('location:acc').toUpperCase(),
    valueKey: 'accCount',
  },
  {// 1
    title: i18n.t('location:bag').toUpperCase(),
    valueKey: 'bagCount',
  },
  {// 2
    title: i18n.t('location:shoe').toUpperCase(),
    valueKey: 'shoeCount',
  },
  {// 3
    title: i18n.t('location:rtw').toUpperCase(),
    valueKey: 'rtwCount',
  },
  {// 4
    title: i18n.t('location:mfl').toUpperCase(),
    valueKey: 'mflCount',
  },
  {// 5
    title: i18n.t('location:omacc').toUpperCase(),
    valueKey: 'omaccCount',
  },
  {// 6
    title: i18n.t('location:lingerie').toUpperCase(),
    valueKey: 'lingerieCount',
  },
  {// 7
    title: i18n.t('location:pets').toUpperCase(),
    valueKey: 'petsCount',
  },
  {// 8
    title: i18n.t('location:kids').toUpperCase(),
    valueKey: 'kidsCount',
  },
  {// 9
    title: i18n.t('location:homeTechActivity').toUpperCase(),
    valueKey: 'homeTechActivityCount',
  },
  {// 10
    title: i18n.t('location:selfCare').toUpperCase(),
    valueKey: 'selfCareCount',
  },
  {// 11
    title: i18n.t('location:actualAcc').toUpperCase(),
    valueKey: 'actualAccCount',
  },
  {// 12
    title: i18n.t('location:actualBag').toUpperCase(),
    valueKey: 'actualBagCount',
  },
  {// 13
    title: i18n.t('location:actualShoe').toUpperCase(),
    valueKey: 'actualShoeCount',
  },
  {// 14
    title: i18n.t('location:actualRtw').toUpperCase(),
    valueKey: 'actualRtwCount',
  },
  {// 15
    title: i18n.t('location:actualMfl').toUpperCase(),
    valueKey: 'actualMflCount',
  },
  {// 16
    title: i18n.t('location:actualLingerie').toUpperCase(),
    valueKey: 'actualLingerieCount',
  },
  {// 17
    title: i18n.t('location:actualPets').toUpperCase(),
    valueKey: 'actualPetsCount',
  },
  {// 18
    title: i18n.t('location:actualKids').toUpperCase(),
    valueKey: 'actualKidsCount',
  },
  {// 19
    title: i18n.t('location:actualHomeTechActivity').toUpperCase(),
    valueKey: 'actualHomeTechActivityCount',
  },
  {// 20
    title: i18n.t('location:actualSelfCare').toUpperCase(),
    valueKey: 'actualSelfCareCount',
  },
];

export const ecommTableDropdownRows = [
  {
    title: i18n.t('location:numberOfSet').toUpperCase(),
    valueKey: 'numberOfSet',
    options: studioSetNumberOptions,
  },
  {
    title: i18n.t('location:typeOfSet').toUpperCase(),
    valueKey: 'typeOfSet',
    options: accSetTypeOptions,
  },
  {
    title: i18n.t('productCategoryL1').toUpperCase(),
    valueKey: 'gender',
    options: genderOptions,
  },
];
